export const white = '#FFFFFF'
export const black = '#000000'

export const green = {
  green1: '#f98435',
  green2: '#f98435'
}

export const red = {
  red1: '#f98435',
  red2: '#F82D3A'
}

export const yellow = {
  yellow1: '#FFE270',
  yellow2: '#F3841E'
}
